export default "__VITE_ASSET__BuFgHnhC__"